<template>
    <FilterLayout title="Brand">
        <div class="dealer-locator__brand-filter">
            <template 
                v-for="(label, brand) in brands"
            >
                <input 
                    class="sr-only"

                    type="checkbox" 
                    name="brand[]" 
                    :value="brand" 
                    :id="`brand-${brand}`" 

                    :checked="isSelected(brand)"
                    @input="toggle(brand)"
                />
                <label 
                    class="dealer-locator__brand-filter--brand" 
                    :for="`brand-${brand}`" 
                >
                    <picture v-if="brand === 'abarth'">
                        <source type="image/webp" srcset="/img/logos/borderless/abarth.webp, /img/logos/borderless/abarth@2x.webp 2x">
                        <img class="dealer-locator__brand-filter--brand-logo" srcset="/img/logos/borderless/abarth.jpg, /img/logos/borderless/abarth@2x.jpg 2x" alt="Abarth">
                    </picture>

                    <img v-else class="dealer-locator__brand-filter--brand-logo" :src="brandLogoPath(`/img/logos/borderless/${brand}.svg`, true)" :alt="label">
                </label>
            </template>
        </div>
    </FilterLayout>
</template>

<script>
    import { defineComponent } from "vue";
    import FilterLayout from "./Filter.vue";
    import { mapGetters, mapActions } from "vuex";
    import brandLogoPath from '../../../modules/brandLogoPath';

    export default defineComponent({
        name: 'Brand',

        components: {
            FilterLayout
        },

        methods: {
            brandLogoPath,
            ...mapActions({
                toggle: 'DealerData/toggleBrand',
            }),
        },

        computed: {
            ...mapGetters({
                brands: 'DealerData/filterableBrands',
                isSelected: 'DealerData/isBrandSelected'
            })
        }
    })
</script>